export default __webpack_public_path__ + "static/media/pic3.3997b109.png";